var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-col",
        [
          _c(
            "section-title",
            [
              _c("v-row", { attrs: { align: "center" } }, [
                _c("img", {
                  staticClass: "mr-4",
                  attrs: {
                    src: require("@/assets/IconCM.svg"),
                    width: "35px",
                    height: "35px",
                    alt: ""
                  }
                }),
                _vm._v(" Selección de clientes ")
              ])
            ],
            1
          ),
          _c("customer-selection", { ref: "customerSelection" }),
          _c(
            "section-title",
            { attrs: { icon: "mdi-clipboard-plus-outline" } },
            [_vm._v("DETALLES DEL INFORME DE SALUD Y GESTIÓN")]
          ),
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-form",
                { ref: "form", staticClass: "pa-4" },
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "", align: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4", lg: "5" } },
                        [
                          _c(
                            "v-menu",
                            {
                              ref: "menu",
                              attrs: {
                                "close-delay": "1000",
                                transition: "scale-transition",
                                "offset-y": "",
                                "max-width": "290px",
                                "min-width": "290px"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              label: "Trimestre",
                                              "prepend-icon": "mdi-calendar",
                                              rules: [_vm.rules.required()]
                                            },
                                            model: {
                                              value: _vm.quarter,
                                              callback: function($$v) {
                                                _vm.quarter = $$v
                                              },
                                              expression: "quarter"
                                            }
                                          },
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.menu,
                                callback: function($$v) {
                                  _vm.menu = $$v
                                },
                                expression: "menu"
                              }
                            },
                            [
                              _c(
                                "v-date-picker",
                                {
                                  attrs: {
                                    type: "month",
                                    "no-title": "",
                                    scrollable: "",
                                    locale: "es",
                                    multiple: "",
                                    color: "rgb(149,193,84)",
                                    "header-color": "rgb(64,139,56)"
                                  },
                                  on: {
                                    "click:month": function($event) {
                                      _vm.$refs.menu.save(
                                        _vm.dateChange(_vm.picker)
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.picker,
                                    callback: function($$v) {
                                      _vm.picker = $$v
                                    },
                                    expression: "picker"
                                  }
                                },
                                [_c("v-spacer")],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "5" } },
                        [
                          _c("v-file-input", {
                            ref: "file",
                            staticClass: "mr-2",
                            attrs: {
                              "show-size": "",
                              "truncate-length": "22",
                              counter: "",
                              "counter-size-string": "",
                              label: "Seleccionar archivo",
                              rules: [_vm.rules.required()],
                              accept: ".pdf"
                            },
                            on: { change: _vm.onFileChange },
                            model: {
                              value: _vm.file,
                              callback: function($$v) {
                                _vm.file = $$v
                              },
                              expression: "file"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "text-right",
                          attrs: { cols: "12", md: "3", lg: "2" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text",
                              attrs: {
                                block: "",
                                color: "green",
                                loading: _vm.isLoading
                              },
                              on: {
                                click: function() {
                                  return _vm.uploadFile()
                                }
                              }
                            },
                            [_vm._v(" Guardar archivo ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }